import { OvlAddDialog } from "../../../_ovlclient/src/global/globals"
import { DialogSYSLoginForm } from "./features/loginform"

export const SYSLogin_Init = () => {
  OvlAddDialog(DialogSYSLoginForm, "SYSLogin")
}
